// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

let measureStyles = Emotion.Css.css({
  maxWidth: "65ch",
  marginInline: "auto",
  width: "100%"
});

let bodyStyles = Emotion.Css.css({
  fontFamily: Theme.Theme.Typography.fontFamily.serif,
  fontSize: "clamp(1.1rem, 2cqi, 1.35rem)",
  lineHeight: "1.8",
  color: Emotion.Utils.Color.textPrimary,
  textWrap: "pretty"
});

let dropCapStyles = Emotion.Css.css({
  "& p:first-of-type::first-letter": {
    float: "left",
    fontSize: "4.5rem",
    lineHeight: "0.8",
    paddingInlineEnd: "0.75rem",
    paddingBlockStart: "0.2rem",
    color: Emotion.Utils.Color.primary,
    fontWeight: "500"
  }
});

let paragraphStyles = Emotion.Css.css({
  fontFamily: Theme.Theme.Typography.fontFamily.serif,
  fontSize: "1.2rem",
  lineHeight: "1.8",
  color: Emotion.Utils.Color.textPrimary,
  margin: "0 0 1.5em",
  textWrap: "pretty"
});

let titleStyles = Emotion.Css.css({
  fontFamily: Theme.Theme.Typography.fontFamily.serif,
  fontSize: "clamp(2rem, 5cqi, 3.5rem)",
  fontWeight: "400",
  letterSpacing: "-0.03em",
  lineHeight: "1.15",
  margin: "0 0 1.5rem",
  textWrap: "balance",
  color: Emotion.Utils.Color.textPrimary
});

function Prose$Prose(props) {
  let __className = props.className;
  let __dropCap = props.dropCap;
  let dropCap = __dropCap !== undefined ? __dropCap : false;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: Emotion.Css.cx([
      measureStyles,
      bodyStyles,
      dropCap ? dropCapStyles : "",
      className
    ])
  });
}

function Prose$Prose$Title(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("h1", {
    children: props.children,
    className: Emotion.Css.cx([
      titleStyles,
      className
    ])
  });
}

let Title = {
  make: Prose$Prose$Title
};

function Prose$Prose$Paragraph(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("p", {
    children: props.children,
    className: Emotion.Css.cx([
      paragraphStyles,
      className
    ])
  });
}

let Paragraph = {
  make: Prose$Prose$Paragraph
};

let Prose = {
  measureStyles: measureStyles,
  bodyStyles: bodyStyles,
  dropCapStyles: dropCapStyles,
  paragraphStyles: paragraphStyles,
  titleStyles: titleStyles,
  make: Prose$Prose,
  Title: Title,
  Paragraph: Paragraph
};

export {
  Prose,
}
/* measureStyles Not a pure module */
